export interface BulkIssueProjectPickerProps {
  exampleMessage: string
}

export function BulkIssueProjectPicker({exampleMessage}: BulkIssueProjectPickerProps) {
  return <article>This is an example: {exampleMessage}</article>
}

try{ BulkIssueProjectPicker.displayName ||= 'BulkIssueProjectPicker' } catch {}